import { observable } from "mobx";
import { Type } from "class-transformer";
import ChargeVehicleWarningReason from "./chargeVehicleWarningReason";
import ClassifiedFuelType from "./classifiedFuelType";
import FuelTypeLimitationResponse from "./fuelTypeLimitationResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargeOrderInstructionsResponse {
  /**
   * Charge order warning reasons.
   */
  @observable
  warningReasons?: ChargeVehicleWarningReason[];

  /**
   * Classified fuel type for VEHICLE_REGISTER_FUEL_TYPE_BASED_EXEMPTION.
   */
  @observable
  classifiedFuelType?: ClassifiedFuelType;

  /**
   * Possible exemption reason IDs.
   */
  @observable
  possibleExemptionReasonIds?: string[];

  @observable
  _possibleExemptionReason?: string[];

  @observable
  @Type(() => FuelTypeLimitationResponse)
  fuelTypeLimitation?: FuelTypeLimitationResponse;
}
